import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import only Serbian by default (primary language)
// Other languages will be loaded on demand
import sr from './locales/sr.json';

// A visitor's explicit choice wins; otherwise the site starts in Serbian
// on every domain (.rs and .com both serve the Serbian site).
const getSavedLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('physiowrld-lang');
    if (saved && ['sr', 'en', 'ru'].includes(saved)) {
      return saved;
    }
  }
  return 'sr';
};

const savedLang = getSavedLanguage();

const resources: Record<string, { translation: unknown }> = {
  sr: { translation: sr },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'sr',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Lazy load other languages when needed
const loadLanguage = async (lang: string) => {
  if (lang === 'sr') return; // Already loaded

  if (!i18n.hasResourceBundle(lang, 'translation')) {
    try {
      let translations;
      if (lang === 'en') {
        translations = (await import('./locales/en.json')).default;
      } else if (lang === 'ru') {
        translations = (await import('./locales/ru.json')).default;
      }
      if (translations) {
        i18n.addResourceBundle(lang, 'translation', translations);
      }
    } catch (error) {
      console.error(`Failed to load ${lang} translations:`, error);
    }
  }
};

// If saved language is not Serbian, load it
if (savedLang !== 'sr') {
  loadLanguage(savedLang).then(() => {
    i18n.changeLanguage(savedLang);
  });
}

// Save language to localStorage when it changes and load resources
i18n.on('languageChanged', async (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('physiowrld-lang', lng);
  }
  await loadLanguage(lng);
});

// Export loadLanguage for use in LanguageSwitcher
export { loadLanguage };
export default i18n;
